import { useRouter } from 'next/router';
import { Header } from '../header';
import { SheetModal } from '@pensionbee/honeypot-ui';
import { useState } from 'react';
import { usePlatformInfo } from '../../hooks/useIsNative';

type DefaultLayoutProps = {
  children: React.ReactNode;
  className?: string;
  hideBackButton?: boolean;
  hideBackButtonOnNativePlatform?: boolean;
  backButtonIcon?: 'Back' | 'Close';
  logoLink?: string;
  backAction?: () => void;
  tooltipContent?: React.ReactNode;
  tooltipTitle?: string;
  toolTipParagraph?: string;
  headerRightAction?: {
    label: string;
    onClick: () => void;
  };
};

const DefaultLayout = ({
  children,
  className,
  hideBackButton,
  hideBackButtonOnNativePlatform,
  backButtonIcon,
  logoLink = '/uk/hive/beehive/summary',
  backAction,
  tooltipContent,
  tooltipTitle,
  toolTipParagraph,
  headerRightAction,
}: DefaultLayoutProps) => {
  const router = useRouter();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleBackAction = backAction ?? (() => router.back());

  const { isNative } = usePlatformInfo();

  return (
    <>
      <Header
        logoLink={logoLink}
        backAction={handleBackAction}
        backButtonIcon={backButtonIcon}
        showBackButton={
          isNative ? !hideBackButtonOnNativePlatform : !hideBackButton
        }
        showTooltip={!!tooltipContent}
        toolTipAction={() => setIsTooltipOpen(true)}
        dataTestId="main-header"
        headerRightAction={headerRightAction}
      />
      <main
        className={`mx-auto max-w-header grid grid-cols-12 pt-96 sm:pt-80 pb-36 px-20 sm:px-28 ${className ?? ''}`}
      >
        <div className="col-span-12 md:col-span-6 md:col-start-4">
          {children}
        </div>
      </main>
      {tooltipContent && tooltipTitle && (
        <SheetModal
          isOpen={isTooltipOpen}
          handleClose={() => setIsTooltipOpen(false)}
          title={tooltipTitle}
          paragraph={toolTipParagraph}
        >
          {tooltipContent}
        </SheetModal>
      )}
    </>
  );
};

export default DefaultLayout;
